module.exports = __webpack_public_path__ + "img/icon_map_38_on_111.5f0a8723.png";